import React from 'react';
import {Carousel, CarouselControl, CarouselIndicators, CarouselItem} from 'reactstrap';
import {CaseStorySection} from "./CaseStorySection";
import {SectionHeader} from "../section-header/SectionHeader";
import {ComponentFrame} from "../../frame/ComponentFrame";
import {isoDateFormat} from "../../util/DateFormat";


export class CaseStoriesCarousel extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      activeIndex: 0,
      list: this.mapCaseStories(this.props.caseStoryList)
    };

    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.goToIndex = this.goToIndex.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
  }

  onExiting() {
    this.animating = true;
  }

  onExited() {
    this.animating = false;
  }

  next() {
    if (this.animating) return;
    const nextIndex = this.state.activeIndex === this.props.caseStoryList.length - 1 ? 0 : this.state.activeIndex + 1;
    this.setState({ activeIndex: nextIndex });
  }

  previous() {
    if (this.animating) return;
    const nextIndex = this.state.activeIndex === 0 ? this.props.caseStoryList.length - 1 : this.state.activeIndex - 1;
    this.setState({ activeIndex: nextIndex });
  }

  goToIndex(newIndex) {
    if (this.animating) return;
    this.setState({ activeIndex: newIndex });
  }

  componentWillReceiveProps(nextProps){
     if(nextProps.caseStoryList){
       this.setState({
         list: this.mapCaseStories(nextProps.caseStoryList)
       })
     }
  }

  mapCaseStories(list){
    if(!list)
      return null;

    return list.map(caseStory => {

      return {
        id: caseStory.id,
        props: {
          slug: caseStory.slug,
          title: caseStory.title && caseStory.title.rendered,
          date: isoDateFormat(caseStory.date),
          excerpt: caseStory.excerpt && caseStory.excerpt.rendered,
          thumbnail: (() => {
            let image = null;

            try {
              image = caseStory._embedded["wp:featuredmedia"][0];
            } catch (e) {
            }

            return image;
          })(),
          heroImage: (() => {
            let image = null;

            try {
              image = caseStory.acf.obx_hero_image.sizes.large;
            } catch (e) {
            }

            return image;
          })()
        }
      };
    });
  }

  render(){
    if(!this.state.list || !Array.isArray(this.state.list) || this.state.list.length === 0)
      return null;

    const isIE = window.navigator.userAgent.indexOf("MSIE ") > 0 || !!window.navigator.userAgent.match(/Trident.*rv\:11\./);

    if(isIE){
      return <CaseStorySection { ...this.state.list[0].props } />;
    }

    const { activeIndex } = this.state;

    this.state.list.forEach( c => c.key = c.id );

    const slides =
      this.state.list.map( caseStory => {
        return (
          <CarouselItem key={caseStory.id}
                        onExiting={this.onExiting}
                        onExited={this.onExited}>
            <CaseStorySection { ...caseStory.props } hideHeader />
          </CarouselItem>
        );
      });

    return (
      <ComponentFrame tag="section"
                      width="full"
                      className="case-story-carousel-container"
                      header={
                        <SectionHeader align="center"
                                       color="white"
                                       title="Related Case Stories"/>
                      }>

        <Carousel activeIndex={activeIndex}
                  next={this.next}
                  previous={this.previous} >
          <CarouselIndicators items={this.state.list} activeIndex={activeIndex} onClickHandler={this.goToIndex} />
          {slides}
          <CarouselControl direction="prev" directionText="Previous" onClickHandler={this.previous} />
          <CarouselControl direction="next" directionText="Next" onClickHandler={this.next} />
        </Carousel>

      </ComponentFrame>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/case-stories/CaseStoriesCarousel.js